document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#ProductForm');
  if (form) {
    const variantsElement = form.querySelector('[data-product-variants]');
    const variants = variantsElement ? JSON.parse(variantsElement.textContent) : [];
    const optionSelects = [...form.querySelectorAll('[data-option-index]')];
    const idInput = form.querySelector('[data-variant-id]');
    const submit = form.querySelector('.product-form__submit');
    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cents / 100); }
      catch (error) { return (cents / 100).toFixed(2) + ' ' + currency; }
    };
    const updateVariant = () => {
      const values = optionSelects.map(select => select.value);
      const variant = variants.find(v => v.options.every((value, i) => value === values[i]));
      if (!variant) {
        if (idInput) idInput.value = '';
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (submit) { submit.disabled = !variant.available; submit.textContent = variant.available ? `Add to bag — ${formatMoney(variant.price)}` : 'Sold out'; }
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
    };
    optionSelects.forEach(select => select.addEventListener('change', updateVariant));
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const itemHost = document.querySelector('[data-cart-items]');
  const countHost = document.querySelector('[data-drawer-count]');
  const subtotalHost = document.querySelector('[data-cart-subtotal]');
  const money = cents => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  };
  const openDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    overlay.hidden = false; document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-cart-close]')?.focus();
  };
  const closeDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
    overlay.hidden = true; document.body.style.overflow = '';
  };
  const renderCart = cart => {
    if (countHost) countHost.textContent = cart.item_count;
    if (subtotalHost) subtotalHost.textContent = money(cart.total_price);
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = cart.item_count);
    if (!itemHost) return;
    if (!cart.items.length) { itemHost.innerHTML = '<p class="cart-drawer__loading">Your bag is waiting for a story.</p>'; return; }
    itemHost.innerHTML = cart.items.map(item => `
      <article class="cart-drawer__item">
        <a href="${item.url}">${item.image ? `<img src="${item.image}" alt="">` : '<div></div>'}</a>
        <div><a class="cart-drawer__item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
          <div class="cart-drawer__item-meta">${item.variant_title && item.variant_title !== 'Default Title' ? `${escapeHtml(item.variant_title)}<br>` : ''}Qty: ${item.quantity}<br>${money(item.final_line_price)}</div>
          <button class="cart-drawer__remove" type="button" data-remove-key="${escapeHtml(item.key)}">Remove</button>
        </div>
      </article>`).join('');
  };
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const refreshCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Could not load cart');
    renderCart(await response.json());
  };
  document.querySelectorAll('.cart-link').forEach(link => link.addEventListener('click', async event => {
    if (!drawer) return;
    event.preventDefault();
    try { await refreshCart(); openDrawer(); } catch (error) { window.location.href = link.href; }
  }));
  document.querySelector('[data-cart-close]')?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeDrawer(); });
  itemHost?.addEventListener('click', async event => {
    const button = event.target.closest('[data-remove-key]');
    if (!button) return;
    button.disabled = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/change.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:button.dataset.removeKey,quantity:0})});
      if (!response.ok) throw new Error('Could not remove item');
      renderCart(await response.json());
    } catch (error) { button.disabled = false; button.textContent = 'Could not remove — retry'; }
  });
  document.querySelectorAll('form.quick-add').forEach(quickForm => quickForm.addEventListener('submit', async event => {
    if (!drawer) return;
    event.preventDefault();
    const button = quickForm.querySelector('button[type="submit"]');
    if (button) { button.disabled = true; button.dataset.originalText = button.textContent; button.textContent = 'Adding…'; }
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Accept':'application/json'},body:new FormData(quickForm)});
      if (!response.ok) throw new Error('Could not add item');
      await refreshCart(); openDrawer();
      if (button) button.textContent = 'Added ✓';
    } catch (error) {
      quickForm.submit();
    } finally {
      if (button) { setTimeout(() => { button.disabled = false; button.textContent = button.dataset.originalText || 'Add to bag +'; }, 1200); }
    }
  }));
});